<main class="page">
  <div class="glow" aria-hidden="true"></div>
  <div class="grain" aria-hidden="true"></div>
  <app-brand class="backdrop" [draw]="true" aria-hidden="true" />

  <section class="card">
    <div class="brand">
      <app-brand class="logo" />
      <span class="product">SSO</span>
    </div>

    @if (done(); as outcome) {
      <h1 class="title">
        @if (outcome === 'logout') {
          Sessione chiusa
        } @else {
          Sei ancora connesso
        }
      </h1>
      <p class="lead">
        @if (outcome === 'logout') {
          L'accesso unico è stato chiuso su tutte le applicazioni che lo condividono. Puoi chiudere
          questa scheda.
        } @else {
          Non è stato chiuso nulla. L'applicazione da cui sei partito non ha indicato una pagina di
          ritorno, quindi puoi chiudere questa scheda.
        }
      </p>
    } @else if (!hasRequest) {
      <h1 class="title">Richiesta non valida</h1>
      <p class="lead">
        Questa pagina si apre solo durante un'uscita avviata da un'applicazione. Non c'è nulla da
        confermare.
      </p>
    } @else {
      <h1 class="title">Vuoi uscire?</h1>
      <p class="lead">
        Uscendo chiudi l'accesso unico, quindi la sessione di <b>tutte</b> le applicazioni che lo
        condividono, non solo di quella da cui sei partito.
      </p>
    }

    @if (errorMessage(); as message) {
      <p class="banner banner-error" role="alert">
        <svg class="banner-icon" viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="10" cy="10" r="7.6" fill="none" stroke="currentColor" stroke-width="1.5" />
          <path d="M10 6.4v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <circle cx="10" cy="13.9" r="0.95" fill="currentColor" />
        </svg>
        <span>{{ message }}</span>
      </p>
    }

    @if (hasRequest && done() === null && !expired()) {
      <div class="actions">
        <button type="button" class="btn btn-ghost" [disabled]="locked()" (click)="cancel()">
          Resta connesso
        </button>
        <button type="button" class="btn btn-primary" [disabled]="locked()" (click)="confirm()">
          @if (submitting() || redirecting()) {
            <span class="spinner" aria-hidden="true"></span>
          }
          <span>
            @if (redirecting()) {
              Reindirizzamento…
            } @else if (submitting()) {
              Uscita in corso…
            } @else {
              Esci
            }
          </span>
        </button>
      </div>
    }
  </section>
</main>
